export default __webpack_public_path__ + "static/bespoke_developers-3b210c5f7fb923d99f35dd53a4997ba1.png";